export default __webpack_public_path__ + "static/media/1890.e6dc355e.png";